import { render, staticRenderFns } from "./Speciality.vue?vue&type=template&id=6e9d4224&scoped=true&"
import script from "./Speciality.vue?vue&type=script&lang=js&"
export * from "./Speciality.vue?vue&type=script&lang=js&"
import style0 from "./Speciality.vue?vue&type=style&index=0&id=6e9d4224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9d4224",
  null
  
)

export default component.exports